import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_Radio } from '../../../../design/inputs/radio/S_Radio';
import { RowLayout } from '../../../common/layouts/rowLayout/RowLayout';
import { INFERENCE_TYPE, TRAINING_TYPE } from '../../jobs.model';

interface JobTypeRadiosProps {
  handleChangeJobType: (type: TRAINING_TYPE | INFERENCE_TYPE) => Promise<void>;
  isDisabled: boolean;
  isTraining: boolean;
  type: TRAINING_TYPE | INFERENCE_TYPE;
}

export const JobTypeRadios = ({ handleChangeJobType, isDisabled, type, isTraining }: JobTypeRadiosProps): ReactElement => {
  const { t } = useTranslator();

  const types = isTraining ? TRAINING_TYPE : INFERENCE_TYPE;

  const translations: Record<TRAINING_TYPE | INFERENCE_TYPE, TranslationKey> = {
    [TRAINING_TYPE.AUTO]: 'training.type.auto',
    [TRAINING_TYPE.MANUAL]: 'training.type.manual',
    [INFERENCE_TYPE.PROJECT]: 'inference.type.project',
    [INFERENCE_TYPE.DATASET]: 'inference.type.dataset',
  };

  return (
    <RowLayout size='l'>
      {Object.values(types).map((item: TRAINING_TYPE | INFERENCE_TYPE) => (
        <S_Radio
          disabled={isDisabled}
          key={item}
          id={item}
          label={t(translations[item])}
          onChange={(): void => {
            void handleChangeJobType(item);
          }}
          checked={type === item}
        />
      ))}
    </RowLayout>
  );
};
